<template>
    <!-- Filter Form --> 
    <div class="w3-card w3-round w3-white">
        <div class="w3-container">
            <div class="w3-left-align">
                <div v-if="user">
                    <div v-if="userFeed">
                        Conversations that {{user.name}}:<br/>
                        <input @change="toggleCreatedByUser()" type="checkbox" id="createdByUser" v-model="convoSearchForm.createdByUser">
                        <label for="createdByUser"> Created</label>
                        <br />
                        <input @change="toggleLikedByUser()" type="checkbox" id="jybedByUser" v-model="convoSearchForm.jybedByUser">
                        <label for="jybedByUser"> Endorsed</label>
                        <br />
                    </div>
                    <div v-if="isAuthenticated">
                        Conversations that I:<br/>
                        <input @change="toggleCreatedByMe()" type="checkbox" id="createdByMe" v-model="convoSearchForm.createdByMe">
                        <label for="createdByUser"> Created</label>
                        <br />
                        <input @change="toggleLikedByMe()" type="checkbox" id="jybedByMe" v-model="convoSearchForm.jybedByMe">
                        <label for="jybedByUser"> Endorsed </label>
                        <input @change="toggleFollowedByMe()" type="checkbox" id="consideredByMe" v-model="convoSearchForm.consideredByMe">
                        <label for="consideredByUser"> Follow</label>
                        <br />
                        <br />
                    </div>
                    <div v-if="isAuthenticated">
                        Conversations that my trustees:<br/>
                        <input @change="toggleCreatedByFollowing()" type="checkbox" id="createdByFollowing" v-model="convoSearchForm.createdByFollowing">
                        <label for="createdByFollowing"> Created </label>
                        <input @change="toggleLikedByFollowing()" type="checkbox" id="likedByFollowing" v-model="convoSearchForm.likedByFollowing">
                        <label for="likedByFollowing"> Endorsed</label>
                        <br />
                    </div>
                </div>
                <br />
                <input @keyup.enter="addSearchTag()" type="text" name="tags" placeholder="TAG" v-model="convoSearchForm.tag" class="w3-margin-bottom">
                <span v-for="(tag) in convoSearchForm.tags" class="w3-tag w3-medium w3-theme-d5 w3-margin-right w3-margin-bottom"> 
                    {{tag}} &nbsp;<a @click="removeSearchTag(tag)" type="button" class="w3-theme-d5"> X</a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
  import ConvoSearch from './ConvoSearch.ts'
  export default ConvoSearch
</script>
